import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styles from './LanguageSwitcher.module.css';

interface LanguageSwitcherProps {
  scrolled?: boolean;
}

export const LanguageSwitcher = ({ scrolled = false }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const location = useLocation();

  const langs = ['it', 'en'] as const;

  /**
   * Crossing between languages means crossing the /en basename, which React
   * Router can't do client-side — this is a real navigation (full page load),
   * to the equivalent path under (or stripped of) /en.
   */
  const switchTo = (lng: 'it' | 'en') => {
    if (lng === i18n.language) return;
    const relPath = location.pathname === '/' ? '' : location.pathname;
    const target = lng === 'en' ? `/en${relPath}` : relPath || '/';
    // eslint-disable-next-line react-hooks/immutability -- intentional browser navigation, not a state mutation
    window.location.href = `${target}${location.hash}`;
  };

  return (
    <div className={`${styles.switcher} ${scrolled ? styles.switcherScrolled : ''}`}>
      {langs.map((lng) => (
        <button
          key={lng}
          onClick={() => switchTo(lng)}
          className={`${styles.lang} ${scrolled ? styles.langScrolled : ''} ${
            i18n.language === lng ? styles.active : ''
          }`}
        >
          {lng}
        </button>
      ))}
    </div>
  );
};
